import {
  FETCH_COMMENTS_REQUEST,
  FETCH_COMMENTS_SUCCESS,
  FETCH_COMMENTS_FAILURE,
  FETCH_COMMENT_REQUEST,
  FETCH_COMMENT_SUCCESS,
  FETCH_COMMENT_FAILURE,
  UPDATE_COMMENTS_REQUEST,
  UPDATE_COMMENTS_FAILURE,
  UPDATE_COMMENTS_SUCCESS,
  DELETE_COMMENTS_REQUEST,
  DELETE_COMMENTS_FAILURE,
  DELETE_COMMENTS_SUCCESS,
  CLEAR_COMMENT_ERRORS,    // Nouvelles imports
  CLEAR_COMMENT_SUCCESS,
} from './actionTypes';

const initialState = {
  comments: [],
  comment: null,
  loadingComment: false,
  errorComment: null,
  commentAdded: null
};

const Comments = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMMENTS_REQUEST:
      return {
        ...state,
        loadingComment: true,
        errorComment: null,
        commentAdded: false
      };
    case FETCH_COMMENTS_SUCCESS:
      return {
        ...state,
        loadingComment: false,
        comments: action.payload,
      };
    case FETCH_COMMENTS_FAILURE:
      return {
        ...state,
        loadingComment: false,
        errorComment: action.payload,
      };
    case FETCH_COMMENT_REQUEST:
      return {
        ...state,
        loadingComment: true,
        errorComment: null,
        commentAdded: false
      };
    case FETCH_COMMENT_SUCCESS:
      return {
        ...state,
        loadingComment: false,
        comment: action.payload,
      };
    case FETCH_COMMENT_FAILURE:
      return {
        ...state,
        loadingComment: false,
        errorComment: action.payload,
      };
    case UPDATE_COMMENTS_REQUEST:
      return {
        ...state,
        loadingComment: true,
        errorComment: null,
        commentAdded: false
      };
    case UPDATE_COMMENTS_SUCCESS:
      return {
        ...state,
        loadingComment: false,
        comment: null,
        commentAdded: true
      };
    case UPDATE_COMMENTS_FAILURE:
      return {
        ...state,
        loadingComment: false,
        errorComment: action.payload,
      };
    case DELETE_COMMENTS_REQUEST:
      return {
        ...state,
        loadingComment: true,
        errorComment: null,
        commentAdded: false
      };
    case DELETE_COMMENTS_SUCCESS:
      return {
        ...state,
        commentAdded: true,
        loadingComment: false,
        comments: state.comments.filter(comment => comment.id !== action.payload),
      };
    case DELETE_COMMENTS_FAILURE:
      return {
        ...state,
        loadingComment: false,
        errorComment: action.payload,
      };
    case CLEAR_COMMENT_ERRORS:
      return {
        ...state,
        errorComment: null,
      };
    case CLEAR_COMMENT_SUCCESS:
      return {
        ...state,
        commentAdded: null,
      };
      
    default:
      return state;
  }
};

export default Comments;